import { disciplinesConstants } from "../_constants";

export const getDisciplinesList = list => ({
  type: disciplinesConstants.DISCIPLINES_LIST,
  list
});



// WEBPACK FOOTER //
// ./src/_actions/disciplines.actions.js